export default "__VITE_ASSET__hFvlDjcl__"